import { render, staticRenderFns } from "./baggage.vue?vue&type=template&id=7db0ba6b&"
import script from "./baggage.vue?vue&type=script&lang=js&"
export * from "./baggage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260420081713/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7db0ba6b')) {
      api.createRecord('7db0ba6b', component.options)
    } else {
      api.reload('7db0ba6b', component.options)
    }
    module.hot.accept("./baggage.vue?vue&type=template&id=7db0ba6b&", function () {
      api.rerender('7db0ba6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/itineraries/internal/baggage.vue"
export default component.exports